<template>
  <div class="modal-wrapper">
    <div class="modal-backdrop"></div>
    <div class="modal-inner">
      <div class="edit-popup popup--email-template-follow">
        <div class="edit-popup__header">
          <div class="edit-popup__title">
            <span class="title">Follow Up</span>
            <span class="sub-title"> {{currentProgram.groupName}}</span>
          </div>
          <div @click="closeModalEmailTemplate" class="edit-popup__close">
          <svg width="1em" height="1em" class="icon icon-close">
            <use
                xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use>
          </svg>
        </div>
        </div>
        <div class="email-template-follow__columns">
          <div class="columns-search">
            <div class="columns-search__input story-templates__table__top">
              <div
                  class="form-control-wrap">
                <input
                    type="text"
                    placeholder="Search"
                    v-model="search"
                    class="form-control-search" />
              </div>
              <a
                  href="javascript:void(0)"
                  class="btn btn--green btn_search-vs"
                  @click="searchEmailTemplate">
                <svg width="1em" height="1em" class="icon icon-search">
                  <use
                      xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-search"></use>
                </svg>
              </a>
            </div>
            <div class="columns-search__tags">
              <div
                  class="edit-popup__tag"
                  v-for="(type, index) in dataTypeEmailTemplate"
                  :key="index"
                  :class="['select-option__tag', {'is-selected__tag': searchEmailTemplates
                    .map(item => item)
                    .includes(type.type)}]"
                  v-if="type.type !== 'FL1' && type.type !== 'FL2'"
              >
                <label
                    @click.prevent.stop="
                            () => {
                              if (
                                !searchEmailTemplates
                                  .map((item) => item)
                                  .includes(type.type)
                              ) {
                                searchEmailTemplates.push(type.type)
                              } else {
                                searchEmailTemplates = searchEmailTemplates.filter(
                                  (i) => !(i === type.type)
                                )
                              }
                            }
                          "
                >

                  <input
                      type="checkbox"
                      :checked="
                    searchEmailTemplates
                    .map(item => item)
                    .includes(type.type)
                  "
                      @click.prevent.stop
                  />

                  <img
                      v-if="type.type === 'CLIMBING'"
                      src="/images/useful/svg/clients-icon1.svg"
                      alt="CLIMBING"
                  />
                  <img
                      v-if="type.type === 'SAFARI'"
                      src="/images/useful/svg/clients-icon2.svg"
                      alt="SAFARI"
                  />
                  <img
                      v-if="type.type === 'ISLAND'"
                      src="/images/useful/svg/clients-icon3.svg"
                      alt="ISLAND"
                  />
                  <img
                      v-if="type.type === 'EXCURSION'"
                      src="/images/useful/svg/clients-icon4.svg"
                      alt="EXCURSION"
                  />

                  <span>{{type.name}}</span>


                </label>

              </div>
              <div class="clear">
                <a class=""
                   :style="{cursor: 'pointer'}"
                   @click="clearSearch"
                >Clear</a >
              </div>
            </div>
            <div class="columns-search__list-templates">
              <div class="list-templates__title">
                <span>Templates for {{typeFollowUp}}</span>
              </div>
              <div class="wrapper__templates">
                <div
                    class="email-template"
                    v-for="(email, index) in dataEmailTemplates" :key="email.id"
                    @click="selectEmailTemplates(email, index)"
                    :class="{'email-template--active': index === selectEmailTemplateIndex }"

                >
                  <span class="email-template__name">{{email.name}}</span>
                  <span class="email-template__date">{{createDate(email.createdAt)}}</span>
                </div>
                <span v-if="dataEmailTemplates.length === 0">No templates</span>
              </div>
            </div>
          </div>

          <div class="columns-description">
            <div v-if="currentEmailTemplate.texts" class="columns-description__title">
              <span v-if="dataEmailTemplates.length !== 0">
                {{currentEmailTemplate.texts[lang.emailTemplateDescription].subject.length > 0
                  ? currentEmailTemplate.texts[lang.emailTemplateDescription].subject
                  : ''}}
              </span>
            </div>
            <div v-if="currentEmailTemplate.texts" class="columns-description__text">
              <div v-if="dataEmailTemplates.length !== 0" class="js-ckeditor">
                <editor
                    :editor="editor"
                    v-model="currentEmailTemplate.texts[lang.emailTemplateDescription].text"
                    disabled
                >
                </editor>
              </div>
            </div>
            <div class="languages-groups">
              <label
                  class="np-detail-collapse__lang np-detail-collapse__lang_checkbox"
                  v-if="lang.emailTemplateDescription === 'EN'">
                <input
                    type="radio"
                    name="lanuage"
                    :checked="lang.emailTemplateDescription === 'EN'" />
                <div class="np-detail-collapse__lang__icon">
                  <svg width="1em" height="1em" class="icon icon-gb">
                    <use
                        xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-gb"></use>
                  </svg>
                </div>
                <span class="np-detail-collapse__lang__text">English</span>
              </label>
              <label
                  class="np-detail-collapse__lang np-detail-collapse__lang_checkbox"
                  v-if="lang.emailTemplateDescription === 'RU'">
                <input
                    type="radio"
                    name="lanuage"
                    :checked="lang.emailTemplateDescription === 'RU'" />
                <div class="np-detail-collapse__lang__icon">
                  <svg width="1em" height="1em" class="icon icon-rus">
                    <use
                        xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-rus"></use>
                  </svg>
                </div>
                <span class="np-detail-collapse__lang__text">Russian</span>
              </label>
              <label
                  class="np-detail-collapse__lang np-detail-collapse__lang_checkbox"
                  v-if="lang.emailTemplateDescription === 'DE'">
                <input
                    type="radio"
                    name="lanuage"
                    :checked="lang.emailTemplateDescription === 'DE'" />
                <div class="np-detail-collapse__lang__icon">
                  <svg width="1em" height="1em" class="icon icon-deu">
                    <use
                        xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-deu"></use>
                  </svg>
                </div>
                <span class="np-detail-collapse__lang__text">Deutch</span>
              </label>
            </div>
            <div class="edit-popup__btns">
              <div class=""></div>

              <div class="edit-popup__btn">
                <button @click="closeModalEmailTemplate" class="btn btn--silver">
                  <span>Cancel</span>
                </button>
                <button :disabled="dataEmailTemplates.length === 0" @click="selectEmailTemplate()" class="btn btn--green">
                  <span>Send</span>
                </button>
              </div>
            </div>
          </div>

        </div>

          <div v-if="isModalSentResult" class="main-content">
            <div class="container-lg">
              <div class="follow-up-result">
                <div class="modal-wrapper">
                  <div class="modal-backdrop"></div>
                  <div class="modal-inner" style="align-items: flex-start;">
                    <a-t-loader class="follow-up__loading" v-if="isLoadingFollowUp"/>
                    <div v-else class="edit-popup edit-popup--follow-up-total-amount">

                      <div v-if="messagesFollowUp.code !== 200" class="result-card">
                        <div class="title">
                          <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="15" cy="15" r="15" fill="#F13C3C"/>
                            <circle cx="15" cy="15" r="12" stroke="white" stroke-width="2"/>
                            <g clip-path="url(#clip0_4917_4790)">
                              <path d="M21.876 18.8091L15.7939 8.27294C15.4414 7.66244 14.5586 7.66244 14.2061 8.27294L8.12397 18.8091C7.77143 19.4196 8.21283 20.1849 8.91791 20.1849H21.0821C21.7872 20.1849 22.2286 19.4196 21.876 18.8091ZM15.0086 11.5175C15.3984 11.5175 15.7137 11.8414 15.7022 12.2312L15.5876 16.2324C15.579 16.5477 15.321 16.797 15.0057 16.797C14.6904 16.797 14.4325 16.5448 14.4239 16.2324L14.3121 12.2312C14.3035 11.8414 14.6159 11.5175 15.0086 11.5175ZM15 18.7546C14.6016 18.7546 14.2777 18.4308 14.2777 18.0324C14.2777 17.634 14.6016 17.3101 15 17.3101C15.3984 17.3101 15.7223 17.634 15.7223 18.0324C15.7223 18.4308 15.3984 18.7546 15 18.7546Z" fill="white"/>
                            </g>
                            <defs>
                              <clipPath id="clip0_4917_4790">
                                <rect width="14" height="14" fill="white" transform="translate(8 7)"/>
                              </clipPath>
                            </defs>
                          </svg>
                          <span>Couldn’t send email</span>
                        </div>
                        <div class="desc">
                          <span>{{messagesFollowUp.text}}</span>
                        </div>
                        <div class="btn">
                          <div @click="isModalSentResult = false" class="btn btn--green">
                            <span>Ok, got it!</span>
                          </div>
                        </div>
                      </div>

                      <div v-if="messagesFollowUp.code === 200" class="result-card">
                        <div class="title">
                          <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="15" cy="15" r="15" fill="#77B017"/>
                            <path d="M13.595 19.8266C13.4805 19.9379 13.3242 20 13.1619 20C12.9995 20 12.8432 19.9379 12.7287 19.8266L9.26926 16.4847C8.91025 16.1379 8.91025 15.5756 9.26926 15.2295L9.70243 14.811C10.0616 14.4642 10.643 14.4642 11.0021 14.811L13.1619 16.8972L18.9979 11.2601C19.3571 10.9133 19.9391 10.9133 20.2976 11.2601L20.7307 11.6786C21.0898 12.0253 21.0898 12.5875 20.7307 12.9338L13.595 19.8266Z" fill="white"/>
                            <circle cx="15" cy="15" r="12" stroke="white" stroke-width="2"/>
                          </svg>
                          <span>Successfully sent</span>
                        </div>
                        <div class="desc">
                          <span>Email has been sent, thank you!</span>
                        </div>
                        <div class="btn">
                          <div @click="isModalSentResult = false, closeModalEmailTemplate()" class="btn btn--green">
                            <span>Ok</span>
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

      </div>
    </div>
  </div>
</template>

<script>
import Vuex from "vuex";
import CKEditor from '@ckeditor/ckeditor5-vue2'
import ClassicEditor from '@/utilites/ckeditor'
import ATLoader from "@/components/Loaders/Loader";
import {getterTypes as getterTypesSettings} from "@/store/modules/settings";
export default {
  name: 'ATModalEmailTemplateFollowUp',
  components: {ATLoader, editor: CKEditor.component},
  props: {
    currentProgram: {
      type: Object,
      required: true
    },
    allEmailTemplates: {
      type: Array,
      required: true
    },
    typeFollowUp: {
      type: String,
      required: true
    },
    currentUser: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      editor: ClassicEditor,
      isModalSentResult: false,
      templateFollowUp: {
        type: "",
        fromWeb: true,
        clientId: null,
        templateId: null,
        lang: "",
        email: "",
        managerData: {
          telegramId: "",
          phone: "",
          signPhotoId: ""
        }
      },
      search: '',
      searchEmailTemplates: [],
      dataEmailTemplates: [],
      dataTypeEmailTemplate: [
        {name: 'FL1', type: 'FL1'},
        {name: 'FL2', type: 'FL2'},
        {name: 'Climbing', type: 'CLIMBING'},
        {name: 'Safari', type: 'SAFARI'},
        {name: 'Island', type: 'ISLAND'},
        {name: 'Invoices', type: 'INVOICES'},
        {name: 'Excursion', type: 'EXCURSION'},
      ],
      lang: {
        emailTemplateDescription: 'EN',
      },
      selectEmailTemplateIndex: 0,
      currentEmailTemplate: {}
    }
  },
  computed: {
    ...Vuex.mapGetters({
      isLoadingFollowUp: getterTypesSettings.isLoadingFollowUp,
      messagesFollowUp: getterTypesSettings.messagesFollowUp
    })
  },
  watch: {
    dataEmailTemplates(){
      // console.log('EDIT dataEmailTemplates')
      if (this.dataEmailTemplates.length > 0) this.currentEmailTemplate = this.dataEmailTemplates[0]
    }
  },
  methods: {
    createDate(createDate) {
      let options = {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
      }
      return new Date(createDate).toLocaleString('en-GB', options)
    },
    closeModalEmailTemplate(){
      this.$emit('closeModalEmailTemplateOptions', false)

      this.clearSearch()
    },
    searchEmailTemplate(){
      this.dataEmailTemplates = this.allEmailTemplates

      if (this.search.length > 0 && !this.searchEmailTemplates.length > 0) {
        this.dataEmailTemplates = this.allEmailTemplates.filter(e => e.name.toLowerCase().includes(this.search.toLowerCase()))
      }

      if (!this.search.length > 0 && this.searchEmailTemplates.length > 0) {
        this.dataEmailTemplates = this.allEmailTemplates.filter(email => this.searchEmailTemplates.every(s => email.tags.includes(s)))
      }

      if (this.search.length > 0 && this.searchEmailTemplates.length > 0) {
        this.dataEmailTemplates = this.allEmailTemplates.filter(e => e.name.toLowerCase().includes(this.search.toLowerCase()))
        this.dataEmailTemplates = this.dataEmailTemplates.filter(email => this.searchEmailTemplates.every(s => email.tags.includes(s)))
      }
    },
    clearSearch() {
      this.search = ''
      this.searchEmailTemplates = []
      this.searchEmailTemplates.push(this.typeFollowUp)
      if (this.searchEmailTemplates.length > 0) {
        this.dataEmailTemplates = this.allEmailTemplates.filter(email => this.searchEmailTemplates.every(s => email.tags.includes(s)))
      }

    },
    selectEmailTemplates(email, index) {
      this.selectEmailTemplateIndex = index
      this.currentEmailTemplate = email
    },
    selectEmailTemplate() {
      this.isModalSentResult = true
      this.$emit('selectEmailTemplateParams', {
        type: this.typeFollowUp,
        fromWeb: true,
        clientId: this.currentProgram.id,
        templateId: this.currentEmailTemplate.id,
        lang: this.currentProgram.lang,
        email: this.currentProgram.email,
        managerData: {
          telegramId: this.currentUser.data.contacts.TELEGRAM_ID,
          phone: this.currentUser.data.contacts.PHONE,
          signPhotoId: this.currentUser.data.signPhoto
        }
      })
    }
  },
  mounted() {
    this.lang.emailTemplateDescription = this.currentProgram.lang
    if (this.allEmailTemplates.length > 0) {
      this.dataEmailTemplates = this.allEmailTemplates
      if (this.dataEmailTemplates.length > 0) this.currentEmailTemplate = this.dataEmailTemplates[0]
    }

    // console.log('>> this.typeFollowUp', this.typeFollowUp)
    this.currentProgram.programTypes.push(this.typeFollowUp)
    this.searchEmailTemplates = this.currentProgram.programTypes.filter(t =>
      t === this.typeFollowUp || t === 'CLIMBING' || t === 'SAFARI' || t === 'ISLAND' || t === 'EXCURSION'
    )
    // console.log('>> this.searchEmailTemplates', this.searchEmailTemplates)

    if (this.searchEmailTemplates.length > 0) {
      this.dataEmailTemplates = this.allEmailTemplates.filter(email => this.searchEmailTemplates.every(s => email.tags.includes(s)))
    }
  }
}
</script>